<template>
  <v-row justify="center">
    <v-col lg="4">
      <v-dialog
        v-model="dialogVisible"
        width="50%"
      >
        <v-card>
          <v-card-title class="indigo--text text--darken-1">
            Введите сумму коррекции
          </v-card-title>
          <v-card-subtitle />
          <v-divider />
          <v-card-text>
            <v-text-field
              v-model="amount"
              label="Сумма зачисления"
              type="number"
            />
          </v-card-text>
          <v-divider />
          <v-card-actions class="d-flex justify-center">
            <v-btn
              color="primary"
              outlined
              @click="closeDialog"
            >
              Закрыть
            </v-btn>
            <v-btn
              color="primary"
              @click="changeEmissionAmount(account)"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import WebApi from "../../shared/modules/web_api"
import { isEmpty, isObject } from "../../shared/modules/is_object"
import { AccountService } from "@/views/loyalty/shared/services/account-service"

export default {
  name: "AccountCustomerCorrectionDialog",
  props: ["account", "dialogVisible"],
  data: () => ({
      accountService: null,
    amount: 0,
    dialog: false,
    webApi: null
  }),
  beforeMount () {
      this.accountService = new AccountService()
    this.webApi = new WebApi(this.$store)
        .editSuccess("Сумма сохранена успешно!")
        .editError("Ошибка при сохранении суммы")
      },
  methods: {
    async changeEmissionAmount (acc) {
      console.log(acc)
      const item = JSON.parse(JSON.stringify(acc))
      item.AccountAccrual.Amount = this.amount
      item.AccountEmission.Amount = this.amount
      await this.accountService.correctionAccount(item)
      acc.AccountEmission.Amount = +acc.AccountEmission.Amount + +this.amount
      acc.AccountAccrual.Amount = +acc.AccountAccrual.Amount - +this.amount
      this.closeDialog()
      console.log(acc.AccountAccrual.Amount, acc.AccountEmission.Amount)
    },
    closeDialog () {
      this.$emit("close")
    }
  }
}
</script>

<style scoped></style>
